import { Routes } from "@angular/router";
import { DashboardComponent } from "./dashboard.component";
import { OrderViewComponent } from "./order-view/order-view.component";
import { OrderUpsertComponent } from "./order-view/order-upsert/order-upsert.component";
import { isFreightPayerGuard } from "../../../shared/auth/guards/is-freight-payer.guard";
import { isOrderEditableGuard } from "../../../shared/auth/guards/is-order-editable.guard";
import { JobbingHomeViewComponent } from "./jobbing-view/jobbing-home-view/jobbing-home-view.component";
import { ContainersHomeViewComponent } from "./containers-home-view/containers-home-view.component";
import { accessToGeneralFreightGuard } from "../../../shared/user/guards/access-to-general-freight.guard";
import { accessToSpecialisedFreightGuard } from "../../../shared/user/guards/access-to-specialised-freight.guard";
import { accessToContainersGuard } from "../../../shared/user/guards/access-to-containers.guard";
import { JobbingUpsertComponent } from "./jobbing-view/jobbing-upsert/jobbing-upsert.component";
import { isJobEditableGuard } from "../../../shared/auth/guards/is-job-editable.guard";
import { ContainerJobUpsertComponent } from "./containers-home-view/container-job-upsert/container-job-upsert.component";

export const loggedInRoutes: Routes = [
  {
    path: 'dashboard',
    children: [
      { path: '', component: DashboardComponent, outlet: 'dashboard' }
    ]
  },
  {
    path: 'order',
    canActivate: [accessToGeneralFreightGuard],
    children: [
      {
        path: 'home',
        children: [
          { path: '', component: OrderViewComponent, outlet: 'dashboard' }
        ]
      },
      {
        path: ':id/edit',
        children: [
          { path: '', component: OrderUpsertComponent, outlet: 'dashboard', canActivate: [isFreightPayerGuard, isOrderEditableGuard] },
        ]
      },
      {
        path: 'create',
        children: [
          { path: '', component: OrderUpsertComponent, outlet: 'dashboard', canActivate: [isFreightPayerGuard] },
        ]
      }
    ],
  },
  {
    path: 'jobbing',
    canActivate: [accessToSpecialisedFreightGuard],
    children: [
      {
        path: 'home',
        children: [
          { path: '', component: JobbingHomeViewComponent, outlet: 'dashboard' }
        ]
      },
      {
        path: ':id/edit',
        children: [
          { path: '', component: JobbingUpsertComponent, outlet: 'dashboard', canActivate: [isFreightPayerGuard, isJobEditableGuard] },
        ]
      },
      {
        path: 'create',
        children: [
          { path: '', component: JobbingUpsertComponent, outlet: 'dashboard', canActivate: [isFreightPayerGuard] },
        ]
      }
    ],
  },
  {
    path: 'containers',
    canActivate: [accessToContainersGuard],
    children: [
      {
        path: 'home',
        children: [
          { path: '', component: ContainersHomeViewComponent, outlet: 'dashboard' }
        ]
      },
      {
        path: ':id/edit',
        children: [
          { path: '', component: ContainersHomeViewComponent, outlet: 'dashboard', canActivate: [isFreightPayerGuard, isOrderEditableGuard] },
        ]
      },
      {
        path: 'create',
        children: [
          { path: '', component: ContainerJobUpsertComponent, outlet: 'dashboard', canActivate: [isFreightPayerGuard] },
        ]
      }
    ],
  },
];
